<section class="tagList">
  <button class="selectTags__back" (click)="back()">
    <img [src]="EIconPath.ARROW_LEFT" />
    @if (ppFileLoaded) {
      {{ 'back_to_excel_csv_import' | ppTranslate }}
    }
    @if (!ppFileLoaded) {
      {{ 'back_to_site_selection' | ppTranslate }}
    }
  </button>

  <div class="tagList__row">
    @if (ppFileLoaded) {
      <h6 class="selectTags__spreadsheet-name">
        {{ 'select_tags_from' | ppTranslate }} <strong>{{ ppFileName }}</strong>
      </h6>
    }

    @if (!ppFileLoaded) {
      <h6 class="selectTags__spreadsheet-name">
        {{ 'select_tags_from' | ppTranslate }} <strong>{{ ppSite.siteName }}</strong>
      </h6>
    }

    @if (
      (ppSite &&
      selectableTags.length !== ppSelectedTags[ppSite.accountId][ppSite.workspaceId].length) ||
      (!ppSite && selectableTags.length !== ppSelectedFileTags.length)
      ) {
      <button
        class="tagList__select-all-button"
        (click)="selectAll()"
        >
        {{ 'select_all' | ppTranslate }}
      </button>
    }

    @if (
      ((ppSite &&
      selectableTags.length === ppSelectedTags[ppSite.accountId][ppSite.workspaceId].length) ||
      (!ppSite && selectableTags.length === ppSelectedFileTags.length)) &&
      (ppSelectedFileTags?.length > 0 ||
      ppSelectedTags[ppSite.accountId][ppSite.workspaceId]?.length > 0)
      ) {
      <button
        class="tagList__select-all-button"
        (click)="deselectAll()"
        >
        {{ 'deselect_all' | ppTranslate }}
      </button>
    }

    @if (
      ((ppSite &&
      selectableTags.length === ppSelectedTags[ppSite.accountId][ppSite.workspaceId].length) ||
      (!ppSite && selectableTags.length === ppSelectedFileTags.length)) &&
      ppSelectedFileTags?.length === 0 &&
      ppSelectedTags[ppSite.accountId][ppSite.workspaceId]?.length === 0
      ) {
      <button
        class="selectAll selectAll--disabled"
        >
        {{ 'select_all' | ppTranslate }}
      </button>
    }
  </div>

  <ul class="tagsContainer">
    @for (tag of ppData; track tag) {
      @if (
        !ppInitialWorkspaceTags.includes(tag) &&
        ppSite &&
        !(
        ppMergedTags.includes(tag) &&
        !ppSelectedTags[ppSite.accountId][ppSite.workspaceId].includes(tag)
        )
        ) {
        <li
          ppTooltip
          [ppTitle]="tag"
          [ppTrimTooltip]="true"
          class="tag"
          [class.tag--selected]="ppSelectedTags[ppSite.accountId][ppSite.workspaceId].includes(tag)"
          (click)="selectTag(tag)"
          >
          {{ tag }}
        </li>
      }
      @if (!ppInitialWorkspaceTags.includes(tag) && !ppSite) {
        <li
          ppTooltip
          [ppTitle]="tag"
          class="tag"
          [class.tag--selected]="ppSelectedFileTags.includes(tag)"
          (click)="selectTag(tag)"
          >
          {{ tag }}
        </li>
      }
      @if (
        ppMergedTags.includes(tag) &&
        !ppSelectedTags[ppSite.accountId][ppSite.workspaceId].includes(tag)
        ) {
        <li
          ppTooltip
          [ppTitle]="'tag_already_selected_on_different_site' | ppTranslate"
          class="tag tag--disabled"
          >
          {{ tag }}
        </li>
      }
      @if (ppInitialWorkspaceTags.includes(tag)) {
        <li
          ppTooltip
          ppTitle="This tag already exists on this site"
          class="tag tag--disabled"
          >
          {{ tag }}
        </li>
      }
    }
  </ul>
</section>
